import { Component, Input } from '@angular/core';
import { SocialMedia } from 'src/app/models/utils/social-media.model';

@Component({
	selector: 'cmv-social-media',
	templateUrl: './social-media.component.html',
	styleUrls: ['./social-media.component.scss'],
})
export class SocialMediaComponent {
	socialMediaList: Array<SocialMedia> = [
		{
			key: 'instagram',
			color: 'red lighten-3',
			icon: 'bi-instagram',
			link: 'https://www.instagram.com/cajamorelia/',
		},
		{
			key: 'facebook',
			color: 'indigo',
			icon: 'bi-facebook',
			link: 'https://www.facebook.com/CajaMorelia/',
		},
		{
			key: 'youtube',
			color: 'red',
			icon: 'bi-youtube',
			link: 'https://www.youtube.com/channel/UCB-nXchsFrP2NzCfdkNBSjw',
		},
		{
			key: 'tiktok',
			color: 'primary',
			icon: 'bi-tiktok',
			link: 'https://www.tiktok.com/@cajamorelia',
		},
		{
			key: 'twitter',
			color: 'blue ligthen-3',
			icon: 'bi-twitter-x',
			link: 'https://twitter.com/caja_morelia',
		},
	];
	@Input() color: string = '#000';
	constructor() {}
}
